export default __webpack_public_path__ + "static/media/hand-in-water.b8ad6240.mp4";